// Events.ts
import mitt from "mitt";

export class Events {
  private emitter = mitt();

  subscribe(topic: string, handler: (data: any) => void): void {
    this.emitter.on(topic, handler);
  }

  publish(topic: string, data?: any): void {
    this.emitter.emit(topic, data);
  }

  unsubscribe(topic: string, handler: (data: any) => void): void {
    this.emitter.off(topic, handler);
  }
}

// EventBusPlugin.ts
import { App, inject } from "vue";

const EventBusKey = Symbol("EventBus");

export function provideEvents(app: App) {
  const events = new Events();
  app.provide(EventBusKey, events);
}

export function useEvents(): Events {
  const events = inject<Events>(EventBusKey);
  if (!events) {
    throw new Error("No event bus provided!");
  }
  return events;
}
